@for (vap of vaps; track vap; let i = $index) {
  <div class="addon-expander addon-expander--checkbox">
    <div class="addon-expander__header">
      <label class="custom-input custom-input--checkbox">
        <input type="checkbox"
          [checked]="vap?.checked"
          [id]="'checkbox' + currentVap?.product_vaps_id + '-' + vap?.session_item_id"
          (click)="checkAddon(i)"
          [class]="'addon-' + currentVap?.product_vaps_id"/>
          <span class="custom-input__indi"></span>
        </label>
        <a [href]="'#addon-vehicle-field-' + vap?.session_item_id"
          class="addon-expander__title"
          [ngClass]="{'collapsed': !vap?.show}"
          data-toggle="collapse"
          aria-expanded="false">
          @if (vap?.description?.length) {
            <h6>{{vap?.description[2]}}</h6>
          }
          <div class="addon-expander__cost" [ngClass]="{'is-active': vap?.is_active}">
            <p>
              <strong class="{vap_id}-{item_id}-price addon-price-{vap_id}">
              {{ globalQuestionService?.accounting.formatMoney(vap?.price)}}</strong> /mo
            </p>
          </div>
          <div class="addon-expander__caret">
            <svg class="icon"></svg>
          </div>
        </a>
      </div>
    </div>
  }
